import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Stack } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import React, { useState } from "react";
import { CompanyType } from '../../../../services/ConfigurationService/types/companyType';
import { useUpdateCompanyMutation } from '../../../../services/ConfigurationService';

export function EditCompanyDialog({ 
    company, 
    open: externalOpen, 
    onClose: externalOnClose 
}: { 
    company: CompanyType;
    open?: boolean;
    onClose?: () => void;
}) {
    const [internalOpen, setInternalOpen] = useState(false);
    const [form, setForm] = useState<CompanyType>({ ...company });
    const [updateCompany] = useUpdateCompanyMutation();

    // Use external open state if provided, otherwise use internal state
    const isOpen = externalOpen !== undefined ? externalOpen : internalOpen;
    
    const handleOpen = () => setInternalOpen(true);
    const handleClose = () => {
        if (externalOnClose) {
            externalOnClose();
        } else {
            setInternalOpen(false);
        }
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handleSave = async () => {
        await updateCompany(form);
        handleClose();
    };

    return (
        <>
            {/* Only show the button if we're using internal state management */}
            {externalOpen === undefined && (
                <Button variant="outlined" color="primary" size="small" startIcon={<EditIcon fontSize="small" />} onClick={handleOpen} sx={{ minWidth: 0, px: 0.5, py: 0.25, fontSize: '0.75rem', height: 28 }}>
                    Edit
                </Button>
            )}
            <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Edit Company</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} mt={1}>
                        <TextField label="ID" name="id" value={form.id} onChange={handleChange} fullWidth margin="dense" disabled />
                        <TextField label="Name" name="name" value={form.name} onChange={handleChange} fullWidth margin="dense" />
                        <TextField label="Street" name="street" value={form.street} onChange={handleChange} fullWidth margin="dense" />
                        <TextField label="City" name="city" value={form.city} onChange={handleChange} fullWidth margin="dense" />
                        <TextField label="State" name="state" value={form.state} onChange={handleChange} fullWidth margin="dense" />
                        <TextField label="Postal Code" name="postalCode" value={form.postalCode} onChange={handleChange} fullWidth margin="dense" />
                        <TextField label="Country" name="country" value={form.country} onChange={handleChange} fullWidth margin="dense" />
                        <TextField label="Contact Email" name="contactEmail" value={form.contactEmail} onChange={handleChange} fullWidth margin="dense" />
                        <TextField label="Phone" name="phone" value={form.phone} onChange={handleChange} fullWidth margin="dense" />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave} variant="contained" color="primary">Save</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


